import './styles.scss';

export const GradientLine = () => {
  return <div className="gradient-line" />;
};
